import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import BudgetApplicationLocations from '../BudgetApplicationLocations';

const ApplicationFormLocationField = ({ field, index, applicationForm, budgetId, parcelsAutocompletion, change, locations, readonly }) =>(
  <div className="box">
    <div className="col-sm-12">
      <h3>{index + 1}. {field.title}</h3>
      <p>{field.description}</p>
      <FieldArray
        name="locations"
        component={BudgetApplicationLocations}
        applicationForm={applicationForm}
        budgetId={budgetId}
        parcelsAutocompletion={parcelsAutocompletion}
        change={change}
        locations={locations}
        readonly={readonly}
      />
    </div>
  </div>
);

ApplicationFormLocationField.propTypes = {
  change: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  applicationForm: PropTypes.object.isRequired,
  budgetId: PropTypes.string.isRequired,
  parcelsAutocompletion: PropTypes.bool,
  locations: PropTypes.array,
  readonly: PropTypes.bool,
};

export default ApplicationFormLocationField;


// WEBPACK FOOTER //
// ./src/components/budget/applicationForm/ApplicationFormLocationField.js